export default __webpack_public_path__ + "static/media/feature5.dd389f07.svg";